// extracted by mini-css-extract-plugin
module.exports = {"button":"PVmcSw","login":"_89z7sg","isMobile":"QaoFiz","iframe":"U_t12q","hideIframe":"qO92te","dialogClassName":"GOG1mg","reset":"kC4TsA","overlay":"Pbcoue"};